export enum OrderDelayMethod {
	VENUE = 1,
	ORDERTYPE = 2,
	THROTTLECOUNT = 3,
	THROTTLEREVENUE = 4,
}
